<template>
  <div class="person-management">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">用户管理</div>
        <div class="rank">
          <div class="person-tabs">
            <div
              class="item first-item"
              @click="changeItem(1)"
              :class="currentItem === 1 ? 'active' : ''"
            >
              用户管理
            </div>
            <div
              class="item second-item"
              @click="changeItem(2)"
              :class="currentItem === 2 ? 'active' : ''"
            >
              角色管理
            </div>
          </div>
          <div v-if="currentItem === 1">
            <user-employee-manage></user-employee-manage>
          </div>
          <div v-if="currentItem === 2">
            <role-setting></role-setting>
          </div>

          <!-- <el-tabs v-model="first">
            <el-tab-pane label="用户管理" name="first">
              <user-employee-manage></user-employee-manage>
            </el-tab-pane> -->
          <!-- <el-tab-pane label="员工信息" name="first">
                  <employee-information></employee-information>
                </el-tab-pane>
                <el-tab-pane label="用户管理" name="second">
                  <user-manage></user-manage>
                </el-tab-pane> -->
          <!-- <el-tab-pane label="角色设置" name="third">
              <role-setting></role-setting>
            </el-tab-pane>
          </!-->
          -->
        </div>

        <!-- <page-change :pageInfo="pageInfo"></page-change> -->
      </div>
    </div>
  </div>
</template>

<script>
import Url from "../../../service/base-url.js";
import { mapActions, mapState } from "vuex";
import { modules } from "../../../store";
import PageChange from "../../common/PageChange";
import UserEmployeeManage from "./PersonManageComponent/UserEmployeeManage";
// import EmployeeInformation from "./PersonManageComponent/EmployeeInformation";
// import UserManage from "./PersonManageComponent/UserManage";
import RoleSetting from "./PersonManageComponent/RoleSetting";
export default {
  name: "PersonManagement",
  components: {
    PageChange,
    UserEmployeeManage,
    // EmployeeInformation,
    // UserManage,
    RoleSetting,
  },
  data() {
    return {
      currentItem: 1,
      first: "first",
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.init, // 当前页数需要调用的函数
        pageSize: 10, // 当前页数
      },
    };
  },
  mounted() {},
  methods: {
    changeItem(type) {
      this.currentItem = type;
    },
  },
  computed: {},
};
</script>
<style lang="stylus">
.person-management{
  .select-container{
    padding-left:210px!important
  }
  // .content-container .titieMian .select-container{
  //   // height:36px!important;
  // }
  position: relative;
}
.person-tabs {
  display: flex;
  position: absolute;
  top: 58px;
  left: 20px;
  .item {
    width: 96px;
    height: 32px;
    background: #FFFFFF;
    border: 1px solid #E3E5EA;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    cursor: pointer;
    &.active {
      background: #3389FF;
      color: #fff;
      border: 1px solid #3389FF;
    }
  }
  .first-item {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px 0px 0px 4px;
    border-right: 0;
  }
  .second-item {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0px 4px 4px 0px;
  }
}
.person-management
  .el-table

  .content-container .titieMian{
    border:none;
  }
  .title-container{
    border:1px solid #DDDDDD;
    border-bottom:none!important;
  }

  .rank
    border:1px solid #DDDDDD;
    border-top:none!important;
    background: #fff;
    padding-top:5px;

    .el-tabs__nav
      white-space: nowrap;
      position: relative;
      left:45%!important;
      .el-tabs__item
        font-size:16px;
        font-family:MicrosoftYaHei;
        font-weight:400;
        color:rgba(102,102,102,1);
      .el-tabs__item.is-active
        font-size:16px;
        font-family:MicrosoftYaHei-Bold;
        font-weight:bold;
        color:rgba(51,137,255,1);
      .el-tabs__active-bar
        position: absolute;
        bottom: 0;
        left: 0;
        width:120px;
        height:2px;
        background:rgba(51,137,255,1);
      // .el-tabs__nav-wrap::after
      //   content: "";
      //   position: absolute;
      //   left: 0;
      //   bottom: 0;
      //   width: 100%;
      //   height: 0.01rem!important;
      //   background-color: #e4e7ed;
      //   z-index: 1;
      // .el-tabs__header
      //   margin:0 0 -5px!important;
</style>
